import AdminUser from './admin';
import ClientUser from './client';

const tenants = {
    admin: AdminUser,
    client: ClientUser
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/user/tenants/index.jsx